import {
  getPurchaseRequestsService,
  type PurchaseRequestDetails,
} from '@arcual/lib-app-platform';
import { defineStore } from 'pinia';
import type { Ref } from 'vue';
import { ref } from 'vue';
import type { EventSourceMessage } from '@microsoft/fetch-event-source';

export const purchaseRequestsByArtworkIdInitialState: { [key: string]: Array<PurchaseRequestDetails> } = {};
export const purchaseRequestsInitialState: Array<PurchaseRequestDetails> = [];

// TODO: redesign the cache similar to others like inventory
const purchaseRequestsStoreName = 'purchaseRequestsStore';
export const usePurchaseRequestsStore = defineStore(purchaseRequestsStoreName, () => {
  const purchaseRequestMap = ref<Record<string, PurchaseRequestDetails>>({});

  // TODO swap for map cache above
  const purchaseRequests: Ref<Array<PurchaseRequestDetails>> = ref(purchaseRequestsInitialState);
  const purchaseRequestsByArtworkId: Ref<{
    [key: string]: Array<PurchaseRequestDetails>
  }> = ref(purchaseRequestsByArtworkIdInitialState);

  const getPurchaseRequest = async (activationId: string, id: string, invalidate = false): Promise<PurchaseRequestDetails> => {
    if (invalidate) {
      delete purchaseRequestMap.value[id];
    }

    let purchaseRequest = purchaseRequestMap.value[id];

    if (purchaseRequest) {
      return purchaseRequest;
    }

    purchaseRequest = await getPurchaseRequestsService().getPurchaseRequestByActivationId(activationId, id);
    purchaseRequestMap.value[id] = purchaseRequest;
    return purchaseRequest;
  };

  const getPurchaseRequests = () => purchaseRequests;

  const getPurchaseRequestsByArtworkId = () => purchaseRequestsByArtworkId;

  const setPurchaseRequests = (newPurchaseRequests: Array<PurchaseRequestDetails>) => {
    purchaseRequests.value = newPurchaseRequests;
  };

  const setPurchaseRequestByArtworkId = (artworkId: string, newPurchaseRequestsByArtworkId: Array<PurchaseRequestDetails>) => {
    purchaseRequestsByArtworkId.value[artworkId] = newPurchaseRequestsByArtworkId;
  };

  /**
   * Reset the store to its initial state
   */
  const reset = () => {
    setPurchaseRequests(purchaseRequestsInitialState);
    purchaseRequestsByArtworkId.value = purchaseRequestsByArtworkIdInitialState;
  };

  const setupPurchaseRequestsSseListener = async (key: string, callback: (eventMessage: EventSourceMessage) => void) =>
    getPurchaseRequestsService().addSseConnectionStorefront(key, callback);

  const removePurchaseRequestsSseListener = async (key: string) =>
    getPurchaseRequestsService().removeSseConnectionStorefront(key);

  return {
    getPurchaseRequest,
    getPurchaseRequests,
    getPurchaseRequestsByArtworkId,
    setPurchaseRequests,
    setPurchaseRequestByArtworkId,
    setupPurchaseRequestsSseListener,
    removePurchaseRequestsSseListener,
    reset,
  };
});
